module.exports = __webpack_public_path__ + "img/green-steps.84a2faa1.svg";